import "./TreeTitle.scss";
import { baseUrl } from "../../../config.js";
import { EventBus } from "../../../eventbus.js";
import { errorDispatch } from "../../../functions/errorDispatch.js";
import { userHasAllRights } from "../../../functions/userRights.js";

export default {
  props: {
    item: Object,
    mySpace: Number,
  },
  data() {
    return {
      company: this.$store.state.company,
    };
  },
  methods: {
    handleInput(e) {
      const input = e.target;
      input.setAttribute("size", input.value.length);
    },
    userCanRename() {
      return userHasAllRights(["rename_folders"], this);
    },
    openFolder() {
      this.item.expanded = true;

      this.$router.push(
        `/${this.$store.state.company}/${
          this.item.myspace ? "myspace" : "home"
        }/expanded/${this.item.id}`
      );
    },

    togglePrivate() {
      if (userHasAllRights(["make-private_folders"], this)) {
        const oldStatus = this.item.private;
        this.item.private = this.item.private == 1 ? 0 : 1;

        let formData = new FormData();

        formData.append("folder", this.item.id);

        this.$axios
          .post(baseUrl + "/folderprivate", formData)
          .then((r) => {
            //refresh folders
            EventBus.$emit(`desktop-files-update`);
          })
          .catch((e) => {
            errorDispatch("private_folder");

            //reset item
            this.item.private = oldStatus;
          });
      }
    },
    handleEditFolderName(e) {
      e.preventDefault();

      //check if user can rename folders
      if (this.userCanRename()) {
        this.item.editFolderName = true;

        //select input and all text

        this.$nextTick(() => {
          if (this.$refs.treeInput) {
            this.$refs.treeInput.focus();
          }
        });
      }
    },
    handleBlur(e) {
      this.item.editFolderName = false;

      //blur input
      const input = e.target;
      input.blur();
      input.setAttribute("size", this.item.name.length);
    },
    handleUpdateName(e) {
      e.preventDefault();

      const oldName = this.item.name;
      const formData = new FormData();
      const input = e.currentTarget;

      //set new name
      this.item.name = input.value;

      //blur input
      input.blur();

      //set size
      input.setAttribute("size", input.value.length);

      //hide input
      this.item.editFolderName = false;

      //update name
      formData.append("foldername", this.item.name);
      formData.append("foldertoupdate", this.item.id);
      formData.append("myspace", this.mySpace);

      this.$axios
        .post(baseUrl + "/folderupdate", formData)
        .then(() => {
          //refresh folders
          EventBus.$emit(`desktop-files-update`);
        })
        .catch((e) => {
          errorDispatch("rename_folder");
          //update failed

          //reset name
          this.item.name = oldName;
        });
    },
  },
};
